import { makeStyles, Toolbar, Typography } from '@material-ui/core';

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    minHeight: 50,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(3),
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.secondary.main,
  },
  title: {
    flex: '1 1 100%',
  },
}));

export const OverdueTableToolbar = ({ numSelected }) => {
  const classes = useToolbarStyles();

  return (
    <Toolbar className={classes.root}>
      {numSelected > 0 && (
        <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
          {numSelected} selected
        </Typography>
      )}
    </Toolbar>
  );
};
